import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import App from './App.tsx';
import './i18n/index.ts';
import './index.css';
// 配置 Monaco Editor 使用本地包加载，避免 CDN 加载不稳定导致编辑器卡在 Loading
import './monaco-setup';
import { useTranslation } from 'react-i18next';

// 创建 QueryClient 实例
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // 数据立即过期
      gcTime: 1000 * 60 * 5, // 5分钟后清理缓存
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Antd 国际化配置组件
const AntdConfigProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'zh' ? zhCN : enUS;

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AntdConfigProvider>
        <App />
      </AntdConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
